import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrCaptureIcon = React.memo<IconProps>(({ 
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M12 0C5.38 0 0 5.38 0 12C0 18.62 5.38 24 12 24C18.62 24 24 18.62 24 12C24 5.38 18.62 0 12 0ZM21.54 15H16.04L20.65 7.01C21.5 8.48 22 10.18 22 12C22 13.04 21.84 14.05 21.54 15ZM8.54 12L10.27 9H13.73L15.46 12L13.73 15H10.27L8.54 12ZM19.36 5.25L16.62 10L12 2C14.91 2 17.53 3.26 19.36 5.25ZM9.83 2.24L12.58 7H3.35C4.73 4.62 7.06 2.86 9.83 2.24ZM2.46 9H7.96L3.35 16.99C2.5 15.52 2 13.82 2 12C2 10.96 2.16 9.95 2.46 9ZM4.64 18.75L7.38 14L12 22C9.09 22 6.47 20.74 4.64 18.75ZM14.17 21.76L11.42 17H20.64C19.26 19.38 16.93 21.14 14.16 21.76H14.17Z" fill={color}/>
  </BaseIcon>
));

AttrCaptureIcon.displayName = 'AttrCaptureIcon';
